"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.file_generatedReceivableInvoice = void 0;
const lodash_1 = __importDefault(require("lodash"));
const calc_agent_1 = require("@finley-technologies/calc-agent");
const common_1 = require("@finley-technologies/common");
const commonTapeNode_1 = require("../../commonTapeNode");
const utils_1 = require("../../utils");
const configSchema = __importStar(require("./schema/UIConfig.jsonschema.generated.json"));
const types_1 = require("./types");
const { isNode, isIntermediateRecord, ...otherProps } = (0, commonTapeNode_1.commonTapeNodeUtils)(types_1.nodeType, types_1.artifactType, configSchema);
// create a new UI node of this type.
const createNewNode = ({ id, loanProductSlug, creditFacilitySlug, suggestedSerialNumber, }) => {
    const friendlyName = `Receivable Invoice ${suggestedSerialNumber}`;
    const nodeData = {
        metadata: {
            tapeBuilderNodeId: id,
            tapeBuilderNodeType: types_1.nodeType,
        },
        configuration: {
            artifactSlug: lodash_1.default.camelCase(friendlyName),
            loanProductSlug,
            creditFacilitySlug,
            description: 'this represents an extracted data from invoice (pdf)',
            assetVerificationConfig: {
                fields: [
                    {
                        comparisonFormula: 'dynamicIntermediateFields.amount = documentation.amount',
                        receivableDocumentionField: 'amount',
                        receivableResponseTapeField: 'dynamicIntermediateFields.amount',
                    },
                    {
                        comparisonFormula: 'baseFields.company_name = documentation.company_name',
                        receivableDocumentionField: 'company_name',
                        receivableResponseTapeField: 'baseFields.company_name',
                    },
                ],
            },
        },
    };
    return nodeData;
};
const getTapeDefinition = ({ tapeBuilder, artifactId, }) => {
    const tapeDefinitionResult = tapeBuilder.generateTapeDefinition(artifactId);
    (0, common_1.finleyAssert)(tapeDefinitionResult.isValid, `tapeDefinitionResult is not valid for ${artifactId}`);
    (0, common_1.finleyAssert)(tapeDefinitionResult.data, `No definition found for ${artifactId}`);
    return tapeDefinitionResult.data;
};
/*
 * validate the configuration for the node. This checks shape as well
 * logical correctness.
 * This function should validate the config wrt rest of the graph as well.
 * if there is an error it should return an array of error messages.
 * if there are no errors it should return an empty array.
 */
const hasValidConfig = ({ graph, node, getUINode, }) => {
    (0, common_1.finleyAssert)(isNode(node), `node must be a ${types_1.nodeType} node`);
    const allowedInputNodes = ['file_intermediateTape'];
    return (0, utils_1.checkEdges)({
        node,
        graph,
        isAllowedInputNode: (uiNode) => allowedInputNodes.includes(uiNode.nodeType),
        getUINode,
        minInputs: 1,
        maxInputs: 1,
        minOutputs: 0,
        maxOutputs: 0,
    });
};
const getGeneratedLoanTapeNode = ({ graph, creditFacilitySlug, loanProductSlug, }) => {
    const generatedLoanTapeNodes = graph.dataTapes.filter((dataTape) => dataTape.type === 'generatedLoanTape' &&
        dataTape.loanProductSlug === loanProductSlug);
    // there could be multiple generatedLoanTape nodes for the same loanProductSlug
    // but different creditFacilitySlug. if we find multiple filter by creditFacilitySlug
    // Note: we did not filter for creditFacilitySlug in the query above
    // because when a LP goes into single CF (preassignedLoanTape) it specifies its CF as null.
    if (generatedLoanTapeNodes.length > 1) {
        const filteredNodes = generatedLoanTapeNodes.filter((node) => node.creditFacilitySlug === creditFacilitySlug);
        (0, common_1.finleyAssert)(filteredNodes.length === 1, `found multiple generatedLoanTape nodes for loanProductSlug: ${loanProductSlug} and creditFacilitySlug: ${creditFacilitySlug}`);
        return filteredNodes[0];
    }
    return generatedLoanTapeNodes[0];
};
// validate given IntermediateRecord.
// this is called after initialial Config validation is done
// and the intermediate record is generated.
// here an instance of ITapeBuilder is available, which can be used
// to inspect any Tape definitions.
const validateIntermediateTape = ({ graph, tape, tapeBuilder, }) => {
    // funding request
    (0, common_1.finleyAssert)(isIntermediateRecord(tape), `validateIntermediateTape: tape is not an ${types_1.artifactType}`);
    (0, common_1.finleyAssert)(tape.type === 'receivableInvoice', 'node is not a fundingRequest');
    const { assetVerificationConfig } = tape.configuration;
    const { fields: assetVerificationFields } = assetVerificationConfig;
    // we want to ensure that input node has correct definition.
    // and matches the configuration here.
    const inputs = (0, utils_1.getInputTapeIds)({ tapeId: tape.id, graph });
    (0, common_1.finleyAssert)(inputs.length === 1, 'expected 1 input to receivableInvoice');
    const receivableInvoiceTapeDefinition = getTapeDefinition({
        tapeBuilder,
        artifactId: inputs[0],
    });
    const receivableInvoiceTapeFields = receivableInvoiceTapeDefinition.baseFields.map(({ field }) => field);
    // receivableInvoiceTapeFields are of the format
    // fieldName#value
    // fieldName#confidence
    // fieldName#error
    // fieldName#raw (optional - only available where fieldName#value is sanitized)
    // filter for fieldName#value
    const availableDocumentationFields = receivableInvoiceTapeFields
        .filter((field) => field.includes('#value'))
        .map((field) => field.split('#')[0]);
    const missingDocumentationFields = assetVerificationFields.filter((field) => !availableDocumentationFields.includes(field.receivableDocumentionField));
    if (missingDocumentationFields.length > 0) {
        return missingDocumentationFields.map((field) => `field ${field.receivableDocumentionField} is listed in assetVerificationConfig but is missing from  receivableInvoice node configuration`);
    }
    // we want to find loanTape for the given loanProductSlug/creditFacilitySlug
    // and ensure that the fields in assetVerificationConfig are subset of
    // the fields in the generated loan tape for the given loanProductId
    const generatedLoanTapeNode = getGeneratedLoanTapeNode({
        graph,
        creditFacilitySlug: tape.creditFacilitySlug,
        loanProductSlug: tape.loanProductSlug,
    });
    const generatedLoanTapeDefinition = getTapeDefinition({
        tapeBuilder,
        artifactId: generatedLoanTapeNode.id,
    });
    const generatedLoanTapeFields = generatedLoanTapeDefinition.baseFields.map(({ field }) => field);
    // find the list of fields in asset verification config which are prefixed with  "baseFields."
    const assetVerificationBaseFields = assetVerificationFields
        .filter((field) => field.receivableResponseTapeField.startsWith('baseFields.'))
        .map((field) => field.receivableResponseTapeField.split('.')[1]);
    const missingLoanTapeFields = assetVerificationBaseFields.filter((field) => !generatedLoanTapeFields.includes(field));
    if (missingLoanTapeFields.length > 0) {
        return missingLoanTapeFields.map((field) => `field ${field} is listed in assetVerificationConfig but is missing from baseFields definition`);
    }
    // finally validate the comparison formula
    // unfortunately we cannot validate any intermediateCalc references
    // but we should validate the rest.
    const formulaErrors = (0, calc_agent_1.checkAssetDocumentationFormulaErrors)({
        fieldConfigs: assetVerificationFields,
        dynamicIntermediateFields: [],
        baseFields: generatedLoanTapeFields,
        documentationFields: availableDocumentationFields,
        ignoreDynamicIntermediateFields: true,
    });
    return formulaErrors.map((error) => error.errorMessages.join('\n'));
};
/**
 * Represents a UI node with various properties and methods.
 */
// eslint-disable-next-line camelcase
exports.file_generatedReceivableInvoice = {
    // what should node say on the tape-buider node creation menu.
    nodeTypeText: 'Documentation',
    // what is the node type. must be one of the constants defined in TapeBuilderNodeType
    nodeType: types_1.nodeType,
    // expose artifactType
    artifactType: types_1.artifactType,
    isOperation: false,
    isRaw: false,
    isFinal: true,
    // operatin nodes dont render badges.
    badgeTexts: ['Documentation'],
    // schema to validate the configuration against.
    configSchema,
    // creates sample configuration for this node.
    createNewNode,
    // typeguard that checks if the node is of this type.
    isNode,
    isIntermediateRecord,
    ...otherProps,
    // validate the configuration for the node for logical correctness
    hasValidConfig,
    // validate generated config
    validateIntermediateTape,
};
//# sourceMappingURL=uinode.js.map